module.exports = __webpack_public_path__ + "img/chengbendi.f4ba6660.png";